export interface ClinicContactApiResource {
  name: string;
  contact_email: string | null;
  contact_phone: string | null;
  contact_website: string | null;
  address_line1: string | null;
  address_line2: string | null;
  postal_code: string | null;
  city: string | null;
}

export interface ClinicContact {
  name: string;
  contactEmail: string | null;
  contactPhone: string | null;
  contactWebsite: string | null;
  addressLines: string[];
}

function present(value: string | null): value is string {
  return value !== null && value.trim().length > 0;
}

export function mapApiResourceToClinicContact(resource: ClinicContactApiResource): ClinicContact {
  const cityLine = [resource.postal_code, resource.city].filter(present).join(' ');
  return {
    name: resource.name,
    contactEmail: resource.contact_email,
    contactPhone: resource.contact_phone,
    contactWebsite: resource.contact_website,
    addressLines: [resource.address_line1, resource.address_line2, cityLine].filter(present),
  };
}

export function hasClinicContactDetails(contact: ClinicContact): boolean {
  return (
    present(contact.contactEmail) ||
    present(contact.contactPhone) ||
    present(contact.contactWebsite) ||
    contact.addressLines.length > 0
  );
}
